export const initialFilters = {
    status: {
      cancelled: false,
    },
    type: {
      purchaseTag: false,
      paidCoupon: false,
    },
    archive: {
      showInArchive: false,
      showAll: false,
    },
  };

export const BENEFIT_DEEP_LINK_BASE_URL = 'https://dl.hot.co.il/b';